export default "__VITE_ASSET__qH0aK9na__"